export default "__VITE_ASSET__c5cac41e__"